module.exports = __webpack_public_path__ + "static/media/arjun.31a97bcf.png";